import { render, staticRenderFns } from "./NotificationAffiliates.vue?vue&type=template&id=c2fee0b0&"
import script from "./NotificationAffiliates.vue?vue&type=script&lang=ts&"
export * from "./NotificationAffiliates.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationAffiliates.vue?vue&type=style&index=0&id=c2fee0b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports